module.exports = __webpack_public_path__ + "img/62_4.57184dfc.png";